import React, { useState } from "react";
import { Modal } from "../../components/admin/Modal";
import { ProductForm } from "../../components/admin/ProductForm";
import { BulkProductForm } from "../../components/admin/BulkProductForm";
import { API_BASE_URL } from "../../API/endpoint";

export const ProductsTab = ({ products, categories, loading, onSave, onDelete, onToggleStatus, onRotate, onBulkSave }) => {
  const [editingProduct, setEditingProduct] = useState(null);
  const [bulkAddMode, setBulkAddMode] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const getThumbnailUrl = (product) => {
    if (product.thumbnailPath) {
      return `${API_BASE_URL}${product.thumbnailPath}`;
    }
    if (product.path && product.path.includes("/uploads/products/")) {
      const filename = product.path.split("/").pop();
      return `${API_BASE_URL}/uploads/thumbnails/thumb_${filename}`;
    }
    return `${API_BASE_URL}${product.path}`;
  };

  const handleSave = async (productData) => {
    const id = productData.get ? productData.get("id") : editingProduct?.id;
    await onSave(id, productData);
    setEditingProduct(null);
  };

  const handleBulkSave = async (productsData) => {
    await onBulkSave(productsData);
    setBulkAddMode(false);
  };

  const filteredProducts = products
    .filter((p) => !selectedCategory || p.category?.id === parseInt(selectedCategory))
    .filter((p) => !searchTerm || p.title.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="admin-section">
      <div className="admin-header">
        <h2>Gestion des Produits</h2>
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="btn-add" onClick={() => setEditingProduct({})}>
            + Ajouter un produit
          </button>
          <button
            className="btn-add"
            onClick={() => setBulkAddMode(true)}
            style={{ backgroundColor: "#28a745" }}
          >
            + Ajout plusieurs produits
          </button>
        </div>
      </div>

      {bulkAddMode && (
        <BulkProductForm
          categories={categories}
          onSave={handleBulkSave}
          onCancel={() => setBulkAddMode(false)}
        />
      )}

      <Modal
        isOpen={editingProduct && !bulkAddMode}
        onClose={() => setEditingProduct(null)}
        title={editingProduct?.id ? "Modifier le produit" : "Nouveau produit"}
      >
        <ProductForm
          product={editingProduct || {}}
          categories={categories}
          onSave={handleSave}
          onCancel={() => setEditingProduct(null)}
        />
      </Modal>

      {loading && <p>Chargement...</p>}

      <div className="filter-section" style={{ marginBottom: "20px" }}>
        <div style={{ marginBottom: "10px" }}>
          <label>Rechercher par titre:</label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Tapez pour rechercher..."
            style={{
              padding: "8px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              width: "300px",
              marginLeft: "10px",
            }}
          />
        </div>
        <div>
          <label>Filtrer par catégorie:</label>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{
              padding: "8px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              marginLeft: "10px",
            }}
          >
            <option value="">Toutes les catégories</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <div className="product-admin-table">
          <div className="product-header">
            <div>Image</div>
            <div>Titre</div>
            <div>Description</div>
            <div>Prix</div>
            <div>Catégorie</div>
            <div>Actions</div>
          </div>
          {filteredProducts.map((product) => (
            <div className="product-row" key={product.id}>
              <div className="product-cell">
                {(product.thumbnailPath || product.path) && (
                  <img
                    src={`${getThumbnailUrl(product)}?t=${Date.now()}`}
                    alt={product.title}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
              <div className="product-cell">{product.title}</div>
              <div className="product-cell description-cell">{product.description}</div>
              <div className="product-cell">{product.price} €</div>
              <div className="product-cell">{product.category?.name || "N/A"}</div>
              <div className="product-cell admin-actions">
                <button
                  className="btn-edit"
                  onClick={() => setEditingProduct(product)}
                >
                  <i className="bi bi-pencil"></i>
                </button>
                <button
                  className="btn-secondary"
                  onClick={() => onToggleStatus(product.id, product.enabled)}
                  style={{
                    backgroundColor: product.enabled ? "#f39c12" : "#27ae60",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  <i className={`bi ${product.enabled ? 'bi-x-circle' : 'bi-check-circle'}`}></i>
                </button>
                <button
                  className="btn-delete"
                  onClick={() => onDelete(product.id)}
                >
                  <i className="bi bi-trash"></i>
                </button>
                <button
                  className="btn-rotate"
                  onClick={() => onRotate(product.id)}
                  style={{
                    backgroundColor: "#000000ff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  <i className="bi bi-arrow-clockwise"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
